<template>
    <div>
        <q-uploader
            :url="`${$serverHost}${endpoint}`"
            :headers="headers"
            :style="style"
            :color="color"
            :multiple="multiple"
            :label="label"
            field-name="file"
            flat
            bordered
            square
            @uploaded="onUploaded"
        />
    </div>
</template>

<script>
    export default {
        props: {
            endpoint: {
                type: String,
                required: true,
            },
            headers: {
                type: Array,
                default: () => [{name: 'Authorization', value: `Bearer ${sessionStorage.getItem('authToken')}`}],
            },
            label: {
                type: String,
            },
            multiple: {
                type: Boolean,
                default: false,
            },
            style: {
                type: String,
            },
            color: {
                type: String,
                default: "teal",
            },
        },
        methods: {
            onUploaded(info) {
                this.$emit('uploaded', info);
            },
        }
    }
</script>

<style lang="less" scoped>

</style>